import { render, staticRenderFns } from "./fastsearch.vue?vue&type=template&id=63d431a2&scoped=true"
import script from "./fastsearch.vue?vue&type=script&lang=js"
export * from "./fastsearch.vue?vue&type=script&lang=js"
import style0 from "./fastsearch.vue?vue&type=style&index=0&id=63d431a2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d431a2",
  null
  
)

export default component.exports